import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import { useTable } from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import Swal from 'sweetalert2'; // Import SweetAlert2
import '../styles/noPrint.css'
import ApproverModal from './ApproverModal';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';

const PreviewInventory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const email = localStorage.getItem('email'); 
  const [profileDetails, setProfileDetails] = useState(null);
  const [draftData, setDraftData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([])
  const name = localStorage.getItem('name');
  const centerCode = localStorage.getItem('code')
  const badgeId = localStorage.getItem('badgeId');
  const pin = localStorage.getItem('pin');
  const addContent = 'Below Mentioned Inventory to be added to your department after approval of this voucher.';
  const lessContent = 'Below Mentioned Inventory to be reduced from your department after approval of this voucher.';
  const addContentApproved = 'Below Mentioned Inventory has been added to your department after approval of this voucher.';
  const lessContentApproved = 'Below Mentioned Inventory has been reduced from your department after approval of this voucher.';

  let id = searchParams.get('draftId') ? searchParams.get('draftId') : location.state?.id
  const type =searchParams.get('type')

  const token = localStorage.getItem('token');
  const personId = searchParams.get('personId'); // Get personId from search params
  const [personOptions, setPersonOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [draftId, setDraftID] = useState(null);
  const [departmentForModal, setDepartmentForModal] = useState(null);
  useEffect(() => {
    if (!token) {
      // Redirect to login page with additional data
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=inventory`
      );
      return;
    }

    const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
        setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
      }
    };
    const fetchCenterInfo = async () => {
      try {

        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: {
            'Authorization': `Bearer ${token}`, // Add the JWT token in the header
          },
        });
        setData(response.data[0]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const fetchDraftData = async () => {
      if (id) {
        try {
          setLoading(true);
          const response = await apiClient.get(`${SERVER_BASE}/getDraftById/${id}`);

          setDraftData(response.data);
        } catch (err) {
          setError(err.response?.data?.message || 'Error fetching draft data');
        } finally {
          setLoading(false);
        }
      }
    };
    const fetchPersons = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });
        setPersonOptions(
          response.data.map((person) => ({
            value: person.id,
            label: `${person.firstName} ${person.lastName} - ${person.contactNo}`,
            // Assuming 'firstName' and 'lastName' are available
            mobileNo: person.contactNo,
            badgeId: person.badgeId,
            position: person.position,
            sewadarOf: person.sewadarOf
          }))
        );

      } catch (error) {
        console.error('Error fetching persons for approval:', error);
      }
    };
    fetchProfileDetails();
    fetchDraftData();
    fetchPersons();
    fetchCenterInfo();
  }, [token, navigate, email, searchParams]);
  const handleSendForApproval = () => {
    if (!token) {
      window.location.href = "/";
      return;
    }

    setDraftID(id);
    setDepartmentForModal(draftData.department);
    setModalShow(true);
  };

  const getFilteredOptions = () => {
    return personOptions.filter(
      person =>
        person.position === "Authorized Person" ||
        person.sewadarOf === departmentForModal
    );
  };

  // Handle Modal Submit (send for approval)
  const handleModalSubmit = async (personId) => {

    const selectedPerson = personOptions.find(
      (person) => String(person.value) === String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;
    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${draftId}`,
        { personId, type: 'inventory' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const baseLink = `https://rs.iosystem.in/previewInventory?id=${draftId}`;
      const fullLink = `${baseLink}&draftId=${draftId}&personId=${personId}&type=inventory`;
      const whatsappLink = `https://wa.me/${mobileNo}?text=${encodeURIComponent(
        `Please Approve this ${draftData.type == 'add' ? "Addition" : "Deduction"} in Inventory: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");

      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };
  const closeModal = () => {
    setModalShow(false); // Close the modal
  };

  const handleApprove = () => {
    // SweetAlert2 for PIN input
    Swal.fire({
      title: 'Enter your PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter your PIN.';
        }
        if (value !== pin) {
          return 'Invalid PIN. Please try again.';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with the approval if PIN matches
        const approvedBy = name;
        const approvedByBadge = badgeId;

        // Send the approval request to the backend
        apiClient.post(`${SERVER_BASE}/approveDraft/${id}`, {
          approvedBy,
          approvedByBadge,
        })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Voucher Approved!',
              text: 'The voucher has been approved successfully.',
              confirmButtonText: 'OK',
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Failed to approve the voucher: ${err.response?.data?.message || err.message}`,
              confirmButtonText: 'OK',
            });
          });
      }
      // fetchDraftData();
    });
  };
  const organization = {
    name: data?.centerName,
    addressLine1: data?.addressLine1,
    addressLine2: data?.addressLine2,
    addressLine3: data?.addressLine3,
    mobile1: data?.mobile1,
    mobile2: data?.mobile2,
    gstin: data?.gstin,
    contactPerson1: data?.contactPerson1,
    contactPerson2: data?.contactPerson2,
    position1: data?.position1,
    position2: data?.position2
  };
  const columns = React.useMemo(
    () => [
      { Header: "S.No", Cell: ({ row }) => row.index + 1 },
      {
        Header: 'Item Name',
        accessor: 'item',
      },
      {
        Header: 'Quantity',
        accessor: 'quantity',
        Cell: ({ value }) =>
          Number(value) % 1 === 0 ? parseInt(value) : parseFloat(value).toFixed(2),
      },
      {
        Header: 'UOM',
        accessor: 'uom',
      },
      {
        Header: 'Location',
        accessor: 'location',
      },
      {
        Header: 'Status',
        accessor: 'state',
      },
    ],
    []
  );

  const tableInstance = useTable({
    columns,
    data: draftData?.inventory || [],
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  if (!token) {
    return null; // Return nothing if the user is redirected
  }

  if (loading) {
    return <p className="text-center mt-4">Loading...</p>;
  }

  if (error) {
    return <p className="text-center text-danger mt-4">Error: {error}</p>;
  }

  return (
    <div className="mt-3 d-flex flex-column align-items-center">

      <div className="bg-white p-4 border border-dark">
        <div className="d-flex justify-content-between no-print mb-3">
          {/* Left side - Back button */}
          {type != 'externalAddition' && (
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            Back
          </button>
          )}

          <div>
            {profileDetails &&
              String(profileDetails.id) !== String(personId) &&
              String(profileDetails.id) !== String(draftData?.authorizedPersonId) &&
              (draftData.status !== 'Approved' && draftData.status !== 'Cancelled') && (
                <button className="btn btn-secondary me-2" onClick={handleSendForApproval}>
                  <FontAwesomeIcon icon={faPaperPlane} /> Send for Approval
                </button>
              )}

            {profileDetails &&
              (String(profileDetails.id) === String(personId) ||
                String(profileDetails.id) === String(draftData?.authorizedPersonId)) &&
              draftData.status !== 'Approved' && (
                <button className="btn btn-success" onClick={handleApprove}>
                  Approve
                </button>
              )}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
          {/* Left side: Logo and organization details */}
          <div className="d-flex align-items-start">
            <img src={RSSB_LOGO} alt="Logo" className="me-3" style={{ height: '65px' }} />
            <div className="text-start">
              <h6 className="mb-0">{organization?.name}</h6>
              <p className="mb-0">{organization?.addressLine1}</p>
              <p className="mb-0">{organization?.addressLine2}</p>
              <p className="mb-0">{organization?.addressLine3}</p>
            </div>
          </div>

          {/* Right side: Receiving department, request number, and date */}
          <div className="text-end mt-2" style={{ fontSize: '14px' }}>
            <h6 className="mb-0 fw-bold">{draftData?.department}</h6>
            <p className="mb-0">{draftData?.draftCode}</p>
            <p className="mb-0">
              {" "}
              {draftData?.date
                ? new Intl.DateTimeFormat("en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                }).format(new Date(draftData.date))
                : ""}
            </p>
          </div>
        </div>
        <div className="text-center border-bottom mt-2" style={{ fontSize: '14px', lineHeight: '1.6' }}>
          <h3 className="fw-bold mb-1" style={{ fontSize: '15px' }}>
            {draftData.type === 'add' ? "INVENTORY ADDITION" : "INVENTORY DEDUCTION"}
          </h3>
        </div>
        {draftData ? (
          <div>


            <div className="d-flex justify-content-between mt-1">
              {/* <p><strong>Date:</strong> {moment(draftData.date).format('DD-MMM-YYYY')}</p> */}
              <p><strong>Purpose:</strong> {draftData.purpose}</p>
            </div>
            {/* <div className="d-flex justify-content-between">
              <p><strong>Department:</strong> {draftData.department}</p>
            </div> */}
            {draftData.ledgerId ?
              <div className="d-flex justify-content-between">
                <p><strong>Ledger:</strong> {draftData.ledgerName}</p>
              </div>
              : null}
            <p><strong>{draftData.type === 'add'
              ? (draftData.status === 'Approved' ? addContentApproved : addContent)
              : (draftData.status === 'Approved' ? lessContentApproved : lessContent)}</strong></p>
            <table {...getTableProps()} className="table table-bordered table-striped mt-3">
              <thead className="thead-light">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
                        <div>
              <p><b>Remarks:</b> {draftData.remarks}</p>
            </div>
            <div className="row">
              <div className="col-md-6">
                <p className="mb-1"><strong>Prepared By</strong></p>
                <p className="mb-1">{draftData.createdBy} - {draftData.createdByBadge}</p>
                <p className="mb-1"><strong>Aproved By</strong></p>
                <p className="mb-1">{draftData.approvedBy} - {draftData.approvedByBadge}</p>
              </div>
              <div className="col-md-6 text-end">
                <p className="mb-1"><strong>Authorized Signatory</strong></p>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center">No draft data available.</p>
        )}
      </div>
      <ApproverModal
        show={modalShow}
        title="Send for Approval"
        options={getFilteredOptions()}
        close={closeModal} // Pass close function
        onSubmit={handleModalSubmit}

      />
    </div>
  );
};

export default PreviewInventory;
